import React, { Fragment, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Form, FormGroup, Label, Input, ModalFooter, Row } from 'reactstrap';
import { Btn } from '../../AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import CommonModal from '../../Components/Modals/modal';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import { getnews, ModalToggle, isOpenModal, addnews, isImageOpenModal, updateNewsImage, updatenews, deleteNewsImage, } from '../../store/newsSlice';
import NoImage from '../../assets/images/noimage.png';
import Dropzone from 'react-dropzone-uploader';
import SweetAlert from 'sweetalert2';

const NewsTable = () => {
  const storeVar = useSelector(state => state.news)
  const dispatch = useDispatch();
  const toggle = () => dispatch(ModalToggle());
  const Imagetoggle = () => dispatch(isImageOpenModal());
  const [submit, setSubmit] = useState(false);
  const [formVar, setFormVar] = useState({
    keyword: '',
    limit: 10,
    offset: 0,
    currentPage: 1,
    status: 'ACTIVE',
    modalTitle: null,
    editState: false,
    newsId: '',
    title: '',
    tag: '',
    description: '',
    newsDate: '',
    link: '',
  });

  useEffect(() => {
    dispatch(getnews(formVar.limit, formVar.offset,))
  }, []);

  const pageChange = (page) => {
    const offset = formVar.limit * (page - 1)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      currentPage: page,
      offset: offset
    }))
    dispatch(getnews(formVar.limit, offset))
  };


  const EditToggleModal = (data) => {
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: true,
      categoryId: data.id,
      modalTitle: 'Edit News',
      newsId: data._id,
      title: data.title,
      tag: data.tag,
      description: data.description,
      newsDate: toISODateString(data.newsDate),
      link: data.link,
    }))
  }
  const AddToggleModal = () => {
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: false,
      modalTitle: 'Add News',
      title: '',
      tag: '',
      description: '',
      newsDate: '',
      link: '',
    }))
  }



  const submitNews = () => {
    if (titleValid() || tagValid() || descriptionValid() || newsDateValid() || linkValid()) {
      setSubmit(true)
      return null
    }
    setSubmit(false)
    if (formVar.editState) {
      dispatch(updatenews(formVar.newsId, { title: formVar.title, tag: formVar.tag, newsDate: formatDate(formVar.newsDate), description: formVar.description, link: formVar.link }))
    } else {
      dispatch(addnews({ title: formVar.title, tag: formVar.tag, newsDate: formatDate(formVar.newsDate), description: formVar.description, link: formVar.link }))
    }
  }


  const titleValid = () => {
    if (!formVar.title) {
      return "Title is required";
    }
  }
  const tagValid = () => {
    if (!formVar.tag) {
      return "Tag is required";
    }
  }
  const descriptionValid = () => {
    if (!formVar.description) {
      return "Description is required";
    }
  }
  const newsDateValid = () => {
    if (!formVar.newsDate) {
      return "NewsDate is required";
    }
  }
  const linkValid = () => {
    if (!formVar.link) {
      return "NewsDate is required";
    }
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const toISODateString = (formattedDate) => {
    const [day, month, year] = formattedDate.split('/');
    return `${year}-${month}-${day}`;
  };


  const filesValid = () => {
    if (!formVar.bannerFile) {
      return "Files is required";
    }
  }
  const ImageEditBannerModal = (data) => {
    dispatch(isImageOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      id: data._id,
      modalTitle: 'Update Icon',
      bannerFile: null,
      bannerImageURL: null
    }))
  }
  const handleChangeStatus = ({ meta, file }, status) => {
    if (status === 'done') {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFormVar((prevFormVar) => ({
          ...prevFormVar,
          bannerImageURL: e.target.result,
        }))
      };
      reader.readAsDataURL(file);
      setFormVar((prevFormVar) => ({
        ...prevFormVar,
        bannerFile: file,
      }))
    } else if (status === "removed") {
      setFormVar((prevFormVar) => ({
        ...prevFormVar,
        bannerFile: null,
        bannerImageURL: null,
      }))
    }
  };

  const submitImage = () => {
    if (filesValid()) {
      setSubmit(true)
      return null
    }

    setSubmit(false)
    dispatch(updateNewsImage(formVar.id, formVar.bannerFile))
  }

  const DeleteModel = (data) => {
    SweetAlert.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this imaginary file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    })
      .then((result) => {
        if (result.value) {
          dispatch(deleteNewsImage(data._id,))
        }
      });
  }
  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row>
              <Col md="6">

              </Col>
              <Col md="4">

              </Col>
              <Col md="2" className='d-flex justify-content-end align-items-center'>
                <div className="text-end border-2 w-100">
                  <Btn attrBtn={{ color: 'info-gradien', className: 'w-100', size: 'sm', onClick: AddToggleModal }}>
                    Add News
                  </Btn>
                </div>
              </Col>
            </Row>

          </CardHeader>
          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Title</th>
                  <th scope='col'>Tag</th>
                  <th scope='col'>Image</th>
                  <th scope='col'>News Date</th>
                  <th scope='col'>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.newsData?.map((item, index) => (
                  <tr key={item._id}>
                    <th scope='row'>{index + 1}</th>
                    <td>{item.title}</td>
                    <td>{item.tag}</td>
                    <td className='w-20'>
                      {item.image ? <img className='w-10-r h-5-r' src={item.image} alt="" /> : <img className='w-10-r h-5-r' src={NoImage} alt="" />}
                    </td>
                    <td>{item.newsDate}</td>

                    <td>
                      <div className='d-flex gap-2 align-items-center'>
                        <div className='cursor-pointer bg-light-primary font-primary action-icon'>
                          <i className="fa fa-edit fa-lg" onClick={(e) => EditToggleModal(item)}></i>
                          <div className="tooltipCustom">Edit</div>
                        </div>
                        <div className='cursor-pointer font-success action-icon'>
                          <i className="fa fa-picture-o fa-lg" onClick={(e) => ImageEditBannerModal(item)} />
                          <div className="tooltipCustom">Update Image</div>
                        </div>
                        <div className='cursor-pointer bg-light-info font-danger action-icon'>
                          <i className="fa fa-trash fa-lg" onClick={(e) => DeleteModel(item)}></i>
                          <div className="tooltipCustom">Delete</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {
            storeVar.totalnews <= 0 && (
              <Empty />
            )
          }
        </Card>
        {
          storeVar.totalnews > 0 &&
          <Pagination currentPage={formVar.currentPage} totalItem={storeVar.totalnews}
            itemsPerPage={formVar.limit} showEllipsisAfter={true} visiblePageCount={3} onPageChange={pageChange} />
        }
      </Col>
      <CommonModal isOpen={storeVar.isOpenModal} title={formVar.modalTitle} toggler={toggle} size={'xl'}>
        <Form>
          <FormGroup>
            <Label className="col-form-label" for="recipient-name">Title</Label>
            <Input className="form-control" type="text" placeholder='Enter News Title' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, title: e.target.value }))} value={formVar.title} />
            {submit && titleValid() ? <span className='d-block font-danger'>{titleValid()}</span> : ""}
            <Label className="col-form-label" for="recipient-name">Tags</Label>
            <Input className="form-control" type="text" placeholder='Enter News Tag' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, tag: e.target.value }))} value={formVar.tag} />
            {submit && tagValid() ? <span className='d-block font-danger'>{tagValid()}</span> : ""}
            <Label className="col-form-label" for="recipient-name">Description</Label>
            <textarea rows={3} className="form-control" type="text" placeholder='Enter News Description' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, description: e.target.value }))} value={formVar.description} />
            {submit && descriptionValid() ? <span className='d-block font-danger'>{descriptionValid()}</span> : ""}
            <Label className="col-form-label" for="recipient-name">News Date</Label>
            <Input className="form-control" type="date" placeholder='Enter News Date' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, newsDate: e.target.value }))} value={formVar.newsDate} />
            {submit && newsDateValid() ? <span className='d-block font-danger'>{newsDateValid()}</span> : ""}
            <Label className="col-form-label" for="recipient-name">URL</Label>
            <Input className="form-control" type="text" placeholder='Enter News URL' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, link: e.target.value }))} value={formVar.link} />
            {submit && linkValid() ? <span className='d-block font-danger'>{linkValid()}</span> : ""}
          </FormGroup>
        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: toggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitNews }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>

      <CommonModal isOpen={storeVar.isImageOpenModal} title={formVar.modalTitle} toggler={Imagetoggle} >
        <Form>
          <FormGroup>

            <Label className="col-form-label" for="recipient-name">Update Image</Label>
            <Dropzone
              className='dropzone dz-clickable'
              onChangeStatus={handleChangeStatus}
              maxFiles={1}
              multiple={false}
              // canCancel={false}
              accept="image/*"
              inputContent='Drop A File'
              styles={{
                dropzone: { width: '100%', height: 150 },
                dropzoneActive: { borderColor: 'green' },
              }}
            />
            {submit && filesValid() ? <span className='d-block font-danger'>{filesValid()}</span> : ""}
          </FormGroup>

        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: Imagetoggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitImage }}>Save Changes</Btn>

        </ModalFooter>
      </CommonModal>

    </Fragment>
  );
};

export default NewsTable;
